// Monofocal table will show only benefits that match this array and sort them accordingly
const monoSorting = [
    'cbAntiBreakage',
    'cbAntiScratch',
    'cbAntiReflective',
    'cbHidrorrepelent',
    'cbReducedEyeFatigue',
    'cbThinnerLighter',
    'cbIdealForRimless',
    'cbUVprotection',
    'cbBetterContrast',
    'cbHDtechnology',
    'cbIndividualLenses', 
];
// Multifocal table will show only benefits that match this array and sort them accordingly
const multiSorting = [
    'visualField',
    'cbPerfectSight',
    'cbAntiBreakage',
    'cbAntiScratch',
    'cbAntiReflective',
    'cbHidrorrepelent',
    'cbThinnerLighter',
    'cbIdealForRimless',
    'cbUVprotection',
    'cbBetterContrast',
    'cbHDtechnology',
    'cbIndividualLenses', 
];
const benefits = [
    ...new Set([
        ...monoSorting,
        ...multiSorting
    ])
];

export { benefits, monoSorting, multiSorting };
//# sourceMappingURL=sorting.js.map
